import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';

import { GlobalService } from '../model/global.service';
import { claimRewards } from './claim';


@Injectable()
export class rewardDataService {
    
    constructor(private _globalService: GlobalService,
        private _http: Http) {
    }

   
    public submitdetails(rewardData: claimRewards): Observable<any> {
        let headers = this.getHeaders();

        return this._http
        .post(
            this._globalService.apiHost + 'claimreward',
            JSON.stringify(rewardData),
            {
                headers: headers
            })
            .map(response => response.json())
            .map((response) => {
                return response;
            }).catch(this.handleError);
    }

    private getHeaders(): Headers {
        return new Headers({
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT',
            'Accept': 'application/json',
            // 'Access-Control-Request-Headers': '*',
            'Access-Control-Allow-Credentials': true
        });
    }

    private handleError(error: Response | any) {
        let errorMessage: any = {};
        // Connection error
        if (error.status == 0) {
            errorMessage = {
                success: false,
                status: 0,
                data: "Sorry, there was a connection error occurred. Please try again.",
            };
        }
        else {
            errorMessage = error.json();
        }
        return Observable.throw(errorMessage);
    }
}



// WEBPACK FOOTER //
// ./src/app/claimReward/claim-data.service.ts